
import * as throttle  from '../lib/lodash.throttle.js'
import * as multiclamp from '../lib/multiclamp.js'

const API_URL = location.origin + '/search/suggestions';
const SUGGESTIONS_CONTAINER_SELECTOR = '[data-js="search-suggestions"]';
const SUGGESTION_SELECTOR = '[data-js="suggestion"]';
const MINIMAL_STRING_LENGTH_TO_INVOKE_SEARCH = 3;
const TEXT_LINE_CLAMP = 3;
const NO_RESULTS_FALLBACK_LABEL = 'no results';
const SEARCH_THROTTLE_TIME = 400;

const showNoResultsState = () => {
    const $container = $(SUGGESTIONS_CONTAINER_SELECTOR);
    return $container.html('<div class="suggestion">' + ($container.data('noResultsLabel') || NO_RESULTS_FALLBACK_LABEL) + '</div>');
}

const clearSuggestionsContainer = () => $(SUGGESTIONS_CONTAINER_SELECTOR).html('');

const getSuggestionContainerByInputId = (id) => {
    switch (id) {
        case 'main-search-input':
            return $('form#main-search').find(SUGGESTIONS_CONTAINER_SELECTOR);
        case 'device-search-input':
            return $('form#device-search').find(SUGGESTIONS_CONTAINER_SELECTOR);
        default:
            throw new Error('[ERVAutosuggest][getSuggestionContainerByInputId]Handler for input: "' + id + '" not implemented');
    }
}

const getValidSuggestionData = (suggestionDTO) => {
    if (!suggestionDTO || !suggestionDTO.LinkUrl) {
        return undefined;
    }
    return {
        linkUrl: suggestionDTO.LinkUrl,
        title: suggestionDTO.Title || "",
        content: suggestionDTO.Content || "",
        thumbnailUrl: suggestionDTO.ThumbnailUrl || ""
    }
}

const getThumbnailHtml = (url) => {
    return url ? `<div class="suggestion-image-container">
                        <div class="suggestion-image" style="background-image:url(${url})"></div>
                    </div>`
        : '';
}

const getSingleSuggestionHtml = (suggestion) => {
    const { linkUrl, title, content, thumbnailUrl } = suggestion;

    return `<a class="suggestion" href="${linkUrl}" data-js="suggestion">
                    <div>
                        <h5 data-js="multiclamp" data-clamp="${TEXT_LINE_CLAMP}">${title}</h5>
					    <div data-js="multiclamp" data-clamp="${TEXT_LINE_CLAMP}" class="suggestion-content">${decodeHtml(content)}</div>
                    </div>
                     ${getThumbnailHtml(thumbnailUrl)} 
				</a>`;
}

function decodeHtml(html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value.replace(/[<\/>]/g, '');;
}

const renderSuggestions = (data, searchInputId) => {
    const $container = getSuggestionContainerByInputId(searchInputId);
    if (!data || !data.length) {
        return showNoResultsState();
    }

    $container.html($.map(data, (suggestionDTO) => {
        const validatedSuggestion = getValidSuggestionData(suggestionDTO);
        if (validatedSuggestion) {
            return getSingleSuggestionHtml(validatedSuggestion);
        }
    }));

    $.map($container.find('[data-js="multiclamp"]'), (element) => {
        new multiclamp(element, {
            clamp: element.getAttribute('data-clamp')
        });
    });
}

let currentRequest = null;

const getSuggestions = (event) => {
    const { target: { value, id } } = event;

    if (!value || value.length < MINIMAL_STRING_LENGTH_TO_INVOKE_SEARCH) {
        clearSuggestionsContainer();
        return;
    }
    currentRequest = $.ajax({
        type: 'GET',
        data: 'query=' + value,
        url: API_URL,
        beforeSend: function () {
            if (currentRequest != null) {
                currentRequest.abort();
            }
        },
    })
    .done((data) => {
        renderSuggestions(data, id);
    })
        .fail((xhr) => {
        console.warn(`[ERVAutosuggest][getSuggestions] Status: ${xhr.statusText}`);
    });
}

const init = () => {
    if(!$(SUGGESTIONS_CONTAINER_SELECTOR).length) {
        return;
    }
    $('[id*="-search-input"]').on('input focus', throttle(getSuggestions, SEARCH_THROTTLE_TIME));
}

export default {
     init,
     clearSuggestionsContainer,
     SUGGESTION_SELECTOR
 }
